import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {DRAG_DROP_PASTE} from '@lexical/rich-text';
import {snackbarAtom} from 'atoms/snackbar';
import {handleFiles} from 'components/DSYS/editor/nodes/fileUploadUtil';
import {useRichTextMediaFeatures} from 'components/DSYS/editor/plugins/MediaFeaturesContext';
import {
  isWithinMediaUploadLimit,
  useRichTextMediaUpload,
} from 'components/DSYS/editor/plugins/MediaUploadContext';
import {t} from 'i18next';
import {useSetAtom} from 'jotai';
import {COMMAND_PRIORITY_LOW} from 'lexical';
import {useEffect} from 'react';

export const DragDropPastePlugin = () => {
  const setSnackbarMessage = useSetAtom(snackbarAtom);
  const [editor] = useLexicalComposerContext();
  const mediaUpload = useRichTextMediaUpload();
  const {videoUploads} = useRichTextMediaFeatures();

  useEffect(
    () =>
      editor.registerCommand(
        DRAG_DROP_PASTE,
        (files: File[]) => {
          const validFiles = files.filter((file) => isWithinMediaUploadLimit(file, mediaUpload));

          if (validFiles.length !== files.length) {
            setSnackbarMessage({
              text: t(
                videoUploads
                  ? 'rich_text_upload_size_error_with_video'
                  : 'rich_text_upload_size_error'
              ),
            });
          }

          handleFiles(validFiles, mediaUpload, editor, {
            videoUploads,
            onUploadError: (file) =>
              setSnackbarMessage({text: t('rich_text_upload_failed', {name: file.name})}),
          });
          return true;
        },
        COMMAND_PRIORITY_LOW
      ),
    [editor, mediaUpload, setSnackbarMessage, videoUploads]
  );

  return null;
};
